module.exports = __webpack_public_path__ + "media/long_gq.aba0b191.mp3";